/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpUpdateServerHeader } from "../funcs/remoteMcpUpdateServerHeader.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteMcpServerHeader } from "../models/components/remotemcpserverheader.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateRemoteMcpServerHeaderRequest,
  UpdateRemoteMcpServerHeaderSecurity,
} from "../models/operations/updateremotemcpserverheader.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateRemoteMcpServerHeaderMutationVariables = {
  request: UpdateRemoteMcpServerHeaderRequest;
  security?: UpdateRemoteMcpServerHeaderSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateRemoteMcpServerHeaderMutationData = RemoteMcpServerHeader;

export type UpdateRemoteMcpServerHeaderMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateServerHeader remoteMcp
 *
 * @remarks
 * Update a remote MCP server header
 */
export function useUpdateRemoteMcpServerHeaderMutation(
  options?: MutationHookOptions<
    UpdateRemoteMcpServerHeaderMutationData,
    UpdateRemoteMcpServerHeaderMutationError,
    UpdateRemoteMcpServerHeaderMutationVariables
  >,
): UseMutationResult<
  UpdateRemoteMcpServerHeaderMutationData,
  UpdateRemoteMcpServerHeaderMutationError,
  UpdateRemoteMcpServerHeaderMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateRemoteMcpServerHeaderMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateRemoteMcpServerHeader(): MutationKey {
  return ["@gram/client", "remoteMcp", "updateServerHeader"];
}

export function buildUpdateRemoteMcpServerHeaderMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateRemoteMcpServerHeaderMutationVariables,
  ) => Promise<UpdateRemoteMcpServerHeaderMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateRemoteMcpServerHeader(),
    mutationFn: function updateRemoteMcpServerHeaderMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateRemoteMcpServerHeaderMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(remoteMcpUpdateServerHeader(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
